// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eH","menuControls_styleDefault":"c-a_eJ","menuControls_styleRed":"c-a_eK"};